import { disableHandler as kitDisableHandler, mountViewModel } from '@rdlabo/ionic-angular-kit';
import type { ViewModelHost } from '@rdlabo/ionic-angular-kit';

export class StoreModel {
  readonly disableHandler = kitDisableHandler;
}

export abstract class ViewModelStore<T, K extends keyof T = never> extends StoreModel {
  readonly host: ViewModelHost<T, K>;

  constructor(host: T) {
    super();
    this.host = mountViewModel<T, K>(host, () => this.onMount?.());
  }

  protected onMount?(): void;
}
